import type { UpdateLocationBannerPayload } from '@/shared/api/types/country-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { COUNTRY_QUERY_KEYS } from '@/entities/country/api/country-queries'
import { updateCountryBanner, updateProvinceBanner } from '@/shared/api/services/country-service'

export function useUpdateCountryBannerMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      countryId,
      payload,
    }: {
      countryId: string
      payload: UpdateLocationBannerPayload
    }) => updateCountryBanner(countryId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: COUNTRY_QUERY_KEYS.all })
    },
  })
}

export function useUpdateProvinceBannerMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      countryId,
      provinceId,
      payload,
    }: {
      countryId: string
      provinceId: string
      payload: UpdateLocationBannerPayload
    }) => updateProvinceBanner(countryId, provinceId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: COUNTRY_QUERY_KEYS.all })
    },
  })
}
